import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { AdvisorRoute } from 'services/routes';
import { AdvisorsType } from 'types/course.type';

const AdvisorCard: React.FC<{ advisor: AdvisorsType }> = ({ advisor }) => (
  <div className="relative mt-[64px] flex h-[260px] w-[300px] flex-col items-center rounded-3xl bg-white">
    <div className="isCenter absolute -top-[60px] h-[110px] overflow-hidden rounded-full bg-black60">
      <Image src={advisor.user.avatar} width={110} height={110} alt={advisor.user.name} />
    </div>
    <div className="mt-[72px] font-semibold text-[20px]">{advisor.user.name}</div>
    <div className="mt-1 font-regular text-14 text-center">
      {advisor.skills.map((key) => key.name).join(' , ')}
    </div>
    <div className="text-gray-21 absolute text-[13px] bottom-[72px] mx-[20px] line-clamp-2 overflow-hidden overflow-ellipsis">
      تحصیلات: {advisor.education}
    </div>

    <Link href={AdvisorRoute(advisor.id)}>
      <button
        type="button"
        className="bg-other3 absolute bottom-[16px] text-white py-[12px] w-[260px] rounded-2xl mx-auto"
      >
        رزرو نوبت
      </button>
    </Link>
  </div>
);

export default AdvisorCard;
